import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { modals } from '@/mixins/modal';
import _ from 'lodash';
import AddDomain from './add-domain';
import EditDomain from './edit-domain';

export default Vue.component('site-domains', {
  template: require('./template.html'),
  name: 'site-domains',
  mixins: [guid, modals],
  components: {
    AddDomain,
    EditDomain,
  },
  computed: {
    ...mapGetters(['currentUser', 'currentSite']),
    domains() {
      return _.chain(this.currentSite.domains)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                // only gather the cols the table needs from data
                const e = [];
                _.forEach(this.col, (c) => {
                  e.push(`${row[c]}${row.tld}`);
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .value();
    },
  },
  data() {
    return {
      filterKey: '',
      col: ['name'],
      paginate: ['domainlist'],
      loading: false,
      canAddDomain: true,
      currentDomain: {
        name: '',
        tld: '',
        records: [],
      },
      modals: {
        addDomain: false,
        editDomain: false,
      },
      noAddStatuses: ['IN_PROGRESS', 'QUEUED', 'RECORD_IN_PROGRESS'],
      bounceTip: true,
    };
  },
  created() {
    this.checkDomains('created');
  },
  mounted() {
    // used for the modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    async checkDomains(hook) {
      // currently, only owners can add domains since the
      // install-domain fn only will check the owners services
      this.canAddDomain = true;
      const sslRequests = this.currentUser.services.sslRequests;
      if (sslRequests && sslRequests.length > 0) {
        const activeCert = sslRequests.find(r => r.site === this.currentSite._id);
        if (activeCert && activeCert.status === 'IN_PROGRESS') {
          this.canAddDomain = false;
        }
      }
      this.currentSite.domains.forEach((domain) => {
        if (this.noAddStatuses.includes(domain.status)) {
          this.canAddDomain = false;
        }
      });
      // make sure tips get updated
      if (hook !== 'created') {
        this.bounceTip = false;
        setTimeout(() => {
          this.bounceTip = true;
        }, 1000);
      }
    },
    getTipMsg() {
      let msg = '';
      if (!this.currentUser.owner) {
        msg = 'You are not authorized to add domains.';
      }
      if (!this.canAddDomain) {
        msg = 'You currently have a domain edit or addition in progress. You will need to either cancel it or finish the process to add a new one.';
      }
      return msg;
    },
    manageDomain(domain) {
      this.currentDomain = domain;
      if (!this.canAddDomain && this.noAddStatuses.includes(domain.status)) {
        this.toggleModal('editDomain', 'child');
      } else if (this.canAddDomain) {
        this.toggleModal('editDomain', 'child');
      }
    },
    toggleModal(type, c) {
      const isOwner = this.currentUser.owner && this.canAddDomain;
      const isEditDomain = type === 'editDomain';
      if (isOwner || (!isOwner && isEditDomain)) {
        this.modals[type] = !this.modals[type];
        const content = !c ? this.$refs[type] : this.$refs[type].$el;
        if (this.modals[type]) {
          this.modelMoveOut(content);
        } else {
          this.modalMoveIn(content);
        }
      } else if (this.modals[type]) {
        // allow a close only if the add domain modal is open
        this.modals[type] = false;
        const content = !c ? this.$refs[type] : this.$refs[type].$el;
        this.modalMoveIn(content);
      }
    },
    highlight(ctx, query, d) {
      const c = `${ctx}${d.tld}`;
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    seperateCamalCase(str) {
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`);
    },
    formatErrors(errs) {
      return this.seperateCamalCase(errs.join(' '));
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/domains/index.js